const clouds = [
    {
        path: '/:project_id/show',
        name: 'clouds.project',
        component: () => import('@/pages/Cloud/ProjectShow.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            is_vpc: false,
            layout: 'content',
            title: "Loyiha",
        }
    },
    {
        path: '/projects',
        name: 'clouds.projects',
        component: () => import('@/pages/Cloud/ProjectIndex.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "Loyiha",
        }
    },
    {
        path: '/:project_id/quotas',
        name: 'vpc.project',
        component: () => import('@/pages/Cloud/ProjectShow.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            is_vpc: true,
            layout: 'content',
            title: "Loyiha",
        }
    },
    {
        path: '/:project_id/clouds',
        name: 'clouds.index',
        component: () => import('@/pages/Cloud/VPS/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/clouds/vps',
        name: 'clouds.vps.index',
        component: () => import('@/pages/Cloud/VPS/MyVpsTab.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "Mening serverlarim",
        }
    },
    {
        path: '/:project_id/clouds/vps/create',
        name: 'clouds.vps.create',
        component: () => import('@/pages/Cloud/VPS/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/clouds/:id/show',
        name: 'clouds.vps.show',
        component: () => import('@/pages/Cloud/VPS/Show/ShowServer.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "VPS sotib olish",
        }
    },
    {
        path: '/:project_id/clouds/key-pairs',
        name: 'vpc.key_pairs.index',
        component: () => import('@/pages/Cloud/KeyPair/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "SSH kalitlar",
        }
    },
    {
        path: '/:project_id/clouds/key-pairs/:id/show',
        name: 'vpc.key_pairs.show',
        component: () => import('@/pages/Cloud/KeyPair/EditPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "SSH kalit",
        }
    },
    {
        path: '/:project_id/clouds/volumes',
        name: 'clouds.volumes',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/vpc/load-balancers',
        name: 'vpc.load_balancers',
        component: () => import('@/pages/Cloud/LoadBalancer/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Сеть",
        }
    },
    {
        path: '/:project_id/vpc/load-balancers/:id/show',
        name: 'vpc.load_balancers.edit',
        component: () => import('@/pages/Cloud/LoadBalancer/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Сеть",
        }
    },
    {
        path: '/:project_id/clouds/networks/:tab',
        name: 'clouds.networks',
        component: () => import('@/pages/Cloud/Network/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Сеть",
        }
    },
    {
        path: '/:project_id/vpc/firewalls',
        name: 'vpc.firewalls',
        component: () => import('@/pages/Cloud/Firewall/IndexPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "Firewalls",
        }
    },
    {
        path: '/:project_id/vpc/ips-policies/create',
        name: 'vpc.ips_policies.create',
        component: () => import('@/pages/Cloud/Firewall/Ips/CreatePage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            active_route: "vpc.firewalls",
            title: "IPS Policies",
        }
    },
    {
        path: '/:project_id/vpc/ips-policies/:id/edit',
        name: 'vpc.ips_policies.edit',
        component: () => import('@/pages/Cloud/Firewall/Ips/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "IPS Policies",
        }
    },
    {
        path: '/:project_id/vpc/antivirus-policies/create',
        name: 'vpc.antivirus_policies.create',
        component: () => import('@/pages/Cloud/Firewall/Antivirus/CreatePage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            active_route: "vpc.firewalls",
            title: "Antivirus Policies",
        }
    },
    {
        path: '/:project_id/vpc/antivirus-policies/:id/edit',
        name: 'vpc.antivirus_policies.edit',
        component: () => import('@/pages/Cloud/Firewall/Antivirus/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            active_route: "vpc.firewalls",
            title: "Antivirus Policies",
        }
    },
    {
        path: '/:project_id/vpc/object-groups/:id/edit',
        name: 'vpc.object_groups.edit',
        component: () => import('@/pages/Cloud/Firewall/ObjectGroup/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "Object Group",
        }
    },
    {
        path: '/:project_id/vpc/firewalls/create',
        name: 'vpc.firewalls.create',
        component: () => import('@/pages/Cloud/Firewall/CreatePage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "Firewalls",
        }
    },
    {
        path: '/:project_id/vpc/firewalls/:id/edit',
        name: 'vpc.firewalls.edit',
        component: () => import('@/pages/Cloud/Firewall/EditPage.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            active_route: "vpc.firewalls",
            layout: 'content',
            title: "Firewalls",
        }
    },
    {
        path: '/:project_id/clouds/images',
        name: 'clouds.images',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/clouds/disks',
        name: 'clouds.disks',
        component: () => import('@/pages/Cloud/Disk/Index.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Диски",
        }
    },
    {
        path: '/:project_id/clouds/backups',
        name: 'clouds.backups',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/clouds/file-storages',
        name: 'clouds.file_storages',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    },
    {
        path: '/:project_id/clouds/load-balancers',
        name: 'clouds.load_balancers',
        component: () => import('@/pages/Page/PageSoon.vue'),
        meta: {
            need_project: true,
            requiresAuth: true,
            layout: 'content',
            title: "Profil sozlamalari",
        }
    }
]

export default clouds